import PrintBackgroundSelectorModal from './modal';

export default PrintBackgroundSelectorModal;
